import { createSelector } from 'reselect'
import config from 'config'

const collaborateSelector = state => state.collaborate

const creationToolContainerSelector = createSelector(
	[
		collaborateSelector,
	],
	collaborateState => {

		const presentationId = collaborateState.presentationId
		const appUid = collaborateState.appUid
		let collaborateUrl = ''

		if (presentationId && appUid) {
			collaborateUrl =
				`${config.ct}slideCustom.php`
				+ `?presentationId=${presentationId}`
				+ `&appUid=${appUid}`
				+ '&modal=1&isQuickLaunch=1'
		}

		return {
			collaborateUrl,
		}
	}
)

export default creationToolContainerSelector
